import { Text, TextSize } from 'shared/ui/Text/Text';
import Tip from 'shared/assets/icons/Tip.svg';
import cls from './PolicyCondition.module.scss';

export const PolicyCondition = () => {
    return (
        <div className={cls.conditionWrapper}>
            <div className={cls.card}>
                <div className={cls.conditions}>
                    <div className={cls.block}>
                        <Text color="#7B7B7B" size={TextSize.text_16}>Ежемесячный платеж</Text>
                        <Text color="#353850" size={TextSize.text_18}>19 898,92 ₽</Text>
                    </div>
                    <div className={cls.block}>
                        <div className={cls.tipWrapper}>
                            <Text color="#7B7B7B" size={TextSize.text_16}>Сумма кредита</Text>
                            <Tip className={cls.tipIcon} />
                            <div className={cls.tipContent}>
                                <Text color="#353850" size={TextSize.text_14}>
                                    Сумма указана с учетом начисленных процентов
                                </Text>
                            </div>
                        </div>
                        <Text color="#353850" size={TextSize.text_18}>477 775,76 ₽</Text>
                    </div>
                    <div className={cls.block}>
                        <Text color="#7B7B7B" size={TextSize.text_16}>Процентная ставка</Text>
                        <Text color="#353850" size={TextSize.text_18}>10%</Text>
                    </div>
                </div>
                <div className={cls.block}>
                    <Text color="#7B7B7B" size={TextSize.text_16}>Срок</Text>
                    <Text color="#353850" size={TextSize.text_18}>10 лет</Text>
                </div>
            </div>
            <div className={cls.card}>
                <div className={cls.conditions}>
                    <div className={cls.block}>
                        <Text color="#7B7B7B" size={TextSize.text_16}>Ежемесячный платеж</Text>
                        <Text color="#353850" size={TextSize.text_18}>19 898,92 ₽</Text>
                    </div>
                    <div className={cls.block}>
                        <div className={cls.tipWrapper}>
                            <Text color="#7B7B7B" size={TextSize.text_16}>Сумма кредита</Text>
                            <Tip className={cls.tipIcon} />
                            <div className={cls.tipContent}>
                                <Text color="#353850" size={TextSize.text_14}>
                                    Сумма указана с учетом начисленных процентов
                                </Text>
                            </div>
                        </div>
                        <Text color="#353850" size={TextSize.text_18}>477 775,76 ₽</Text>
                    </div>
                    <div className={cls.block}>
                        <Text color="#7B7B7B" size={TextSize.text_16}>Процентная ставка</Text>
                        <Text color="#353850" size={TextSize.text_18}>10%</Text>
                    </div>
                </div>
                <div className={cls.block}>
                    <Text color="#7B7B7B" size={TextSize.text_16}>Срок</Text>
                    <Text color="#353850" size={TextSize.text_18}>10 лет</Text>
                </div>
            </div>
        </div>
    );
};
